import React, { FC, memo } from 'react';
import { Trans } from 'react-i18next';
import { isMarkMessage } from 'domains/notification/types';
import { Link } from 'react-router-dom';
import css from '../styles.module.scss';
import { TMarkType } from '../types';

const MarkNotification: FC<{
  notification: TMarkType;
  handleMarkAsRead: () => void;
}> = ({ notification, handleMarkAsRead }) => {
  const { message } = notification;

  if (!isMarkMessage(message)) return null;

  return (
    <div className={css.item__content}>
      <div className={css.item__text}>
        <Trans
          i18nKey={
            message.status === 'SUCCESS'
              ? `creative.notification_success`
              : `creative.notification_error`
          }
          values={{
            name: `[${message.creative_internal_id}] ${message.creative_title}`,
          }}
          components={{
            a: (
              <Link
                to={`/main/campaign/${message.campaign_xxhash}/creatives/${message.creative_xxhash}/basic_settings`}
                rel="noopener noreferrer"
                target="_blank"
                onClick={handleMarkAsRead}
              />
            ),
          }}
        />
      </div>
    </div>
  );
};

export default memo(MarkNotification);
